export const SEARCH_CERTIFICATE = {
  longSentence: 'searchResult:Component-Certificado:variant-fraseLonga',
  shortSentence: 'searchResult:Component-Certificado:variant-fraseCurta'
};

export const HOME_TOP_10 = {
  showMatrix: 'eventos-top-10:Component-Trilho_top10:variant-visivel',
  noShowMatrix: 'eventos-top-10:Component-Trilho_top10:variant-oculto'
};

export const SEARCH_RESULT_COMPONENT = 'searchResult:Component-';

export const FILTER_CAROUSEL = 'FiltroTrilhos';

export const PAGE = 'page:';
